import Dexie from 'dexie'
import { resolveDbName } from './platform'

export const DB_SCHEMA_VERSION = 1

/**
 * Phase 1 local-first DB.
 *
 * Notes:
 * - We keep Phase 1 as simple document caches (singleton records) so we can
 *   expand later into normalized tables without breaking the rest of the app.
 * - Each table stores a single record keyed by `id` except `registerOverview`,
 *   which is keyed per location.
 */
export class BluLocalDb extends Dexie {
  /** @type {Dexie.Table<{id: string, value: any, updatedAt: number}, string>} */
  user
  /** @type {Dexie.Table<{id: string, value: any, updatedAt: number}, string>} */
  session
  /** @type {Dexie.Table<{id: string, value: any, updatedAt: number}, string>} */
  locations
  /** @type {Dexie.Table<{id: string, locationId: number|string, value: any, updatedAt: number}, string>} */
  registerOverview
  /** @type {Dexie.Table<{id: string, value: any, updatedAt: number}, string>} */
  posSnapshot

  constructor() {
    super(resolveDbName('blu-local'))

    this.version(DB_SCHEMA_VERSION).stores({
      user: '&id, updatedAt',
      session: '&id, updatedAt',
      locations: '&id, updatedAt',
      registerOverview: '&id, locationId, updatedAt',
      posSnapshot: '&id, updatedAt'
    })
  }
}

export const createDb = () => new BluLocalDb()

